export enum UserMetaData {
    isCognitoUser = 0x1,
    isGlobalUser = 0x2,
    isConnectionZoneUser = 0x4,
    isTermsAndConditionsToBeAccepted = 0x8,
    isPasswordChangedOnNextLogin = 0x10
}
